import React from 'react';
import CaseStudyPage from './CaseStudyPage';
import { caseStudies } from './caseStudyContent';

export default function ManestCaseStudy() {
  return <CaseStudyPage study={caseStudies.manest} />;
}
